<template>
  <div class="container-lg">
    <!--Tabs-->
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <a
          class="nav-link active"
          id="usuarios-tab"
          data-bs-toggle="tab"
          href="#usuarios"
          role="tab"
          aria-controls="usuarios"
          aria-selected="false"
          >Usuarios</a
        >
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          id="beneficios-tab"
          data-bs-toggle="tab"
          href="#beneficios"
          role="tab"
          aria-controls="beneficios"
          aria-selected="true"
          >Beneficios pendientes</a
        >
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <!-- Usuarios -->
      <div
        class="tab-pane fade show active tab-usuarios"
        id="usuarios"
        role="tabpanel"
        aria-labelledby="usuarios-tab"
      >
        <Crud
          ref="crud"
          :columnas="ColumnasUsuarios"
          :facade="Facade"
          v-on:lista-cargada="listaCargada"
        >
          <template slot="modalTitulo">Usuario de Comercio</template>
          <template v-slot:modalCuerpo="propsModal">
            <!-- Comercio -->
            <SelectorComercio
              ref="selectorComercio"
              required
              :idActual="
                propsModal.item.comercio ? propsModal.item.comercio.id : undefined
              "
              v-on:evento-seleccionado="
                comercioSeleccionadoEnModal(propsModal.item, $event)
              "
              class="mb-3"
            />
            <!-- Email -->
            <div class="form-floating mb-3">
              <input
                v-model="propsModal.item.mail"
                required
                type="email"
                class="form-control"
                id="floatingEmail"
                placeholder="correo@ejemplo.com"
              />
              <label for="floatingEmail">Correo electrónico</label>
            </div>
            <!-- Contraseña -->
            <div class="form-floating">
              <input
                v-model="propsModal.item.clave"
                required
                type="text"
                class="form-control"
                id="floatingPassword"
                placeholder="Password"
              />
              <label for="floatingPassword">Contraseña</label>
            </div>
          </template>
        </Crud>
      </div>
      <!-- Beneficios -->
      <div
        class="tab-pane fade tab-beneficios"
        id="beneficios"
        role="tabpanel"
        aria-labelledby="beneficios-tab"
      >
        <Pendientes
          ref="beneficios"
          :columnas="ColumnasBeneficios"
          :facade="BeneficioPendingFacade"
          :modalGrande="true"
        >
          <template v-slot:modalTitulo>Beneficio pendiente</template>
          <template v-slot:modalCuerpo="slotProps">
            <FormularioBeneficio
              :comercioList="comercioList"
              :item="slotProps.item"
              :facade="BeneficioPendingFacade"
              :permiteEditar="false"
            >
            </FormularioBeneficio>
          </template>
        </Pendientes>
      </div>
    </div>
  </div>
</template>

<script>
import BeneficioLogic from "../../data/logica/beneficio";
import { BeneficioPendingFacade } from "../../admin/beneficio/beneficio-pending.facade";
import Crud from "./Crud";
import FormularioBeneficio from "./formularios/FormularioBeneficio.vue";
import objetoACadenaFilter from "../../filtros/objeto.a.cadena.filter";
import Pendientes from "./util/Pendientes.vue";
import SelectorComercio from "./util/SelectorComercio";
import { UsuarioComercioFacade as Facade } from "../../admin/usuario-comercio/usuario-comercio.facade";

const COLUMNAS_USUARIOS = [
  {
    clave: "comercio",
    cabecera: "Comercio",
    transformacion: {
      filtro: objetoACadenaFilter,
      argumentos: ["Sin comercio asignado",-1, "nombre"]
    }
  },
  {
    clave: "mail",
    cabecera: "Correo"
  }
];

export default {
  components: {
    Crud,
    FormularioBeneficio,
    Pendientes,
    SelectorComercio
  },
  data() {
    return {
      comercioList: undefined
    };
  },
  computed: {
    BeneficioPendingFacade() {
      return BeneficioPendingFacade;
    },
    ColumnasBeneficios() {
      return BeneficioLogic.ColumnasAdministrador;
    },
    ColumnasUsuarios() {
      return COLUMNAS_USUARIOS;
    },
    Facade() {
      return Facade;
    }
  },
  methods: {
    comercioSeleccionadoEnModal(item, comercio) {
      item.comercio = comercio;
    },
    listaCargada(lista) {
      const listaComercios = this.$refs.selectorComercio.comercios;
      // Rellenar comercios si la lista de comercios también está cargada
      if (listaComercios && listaComercios.length) {
        this.rellenarComercios(lista);
      }
    }
  },
};
</script>
